import { ActionType, BaseAction, ActionUpdateLayerData, GristEvent, GristStatus } from '../../util/model';

interface State {
    event: GristEvent;
    status: GristStatus;
}

const intitialState: State = {
    event: {
        Time: '',
        SNEvent: {
            L1Jammer: [],
            L2Jammer: [],
            L1Spoofer: [],
            L2Spoofer: []
        },
        CommonEvent: {
            L1Jammer: [],
            L2Jammer: [],
            L1Spoofer: [],
            L2Spoofer: []
        }
    },
    status: {
        Time: '',
        GristStatus: []
    }
}

export const layerDataReducer = (state: State = intitialState, action: BaseAction): State => {
    if (action.type === ActionType.UDPATE_LAYER_DATA) {
        const a = action as ActionUpdateLayerData;
        return {
            ...state,
            [a.payload.dataName]: a.payload.data
        }
    }
    return state;
}
